<kendo-floatinglabel style="width: 100%" (click)="openEdit()" [text]="label">
  <kendo-textbox (focus)="openEdit()" [value]="fullAddress" [readonly]="true">
    <ng-template kendoTextBoxSuffixTemplate>
      <button
        kendoButton
        (click)="openEdit()"
        fillMode="clear"
        icon="edit"
      ></button>
    </ng-template>
  </kendo-textbox>
</kendo-floatinglabel>

<kendo-dialog
  [title]="label"
  *ngIf="edit"
  (close)="closeEdit()"
  [width]="600"
  [minWidth]="450"
>
  <form [formGroup]="form">
    <div class="field">
      <app-autocomplete
        formControlName="country"
        url="/countries"
        searchProp="Countries"
        [isExact]="false"
        [label]="'COMPANY_PROFILE_DATA.OFFICES.COUNTRY' | translate"
      ></app-autocomplete>
    </div>
    <div class="field">
      <app-autocomplete
        formControlName="state"
        url="/states"
        searchProp="States"
        [parentSearchPropValue]="form.get('country')?.value?.id"
        [label]="'COMPANY_PROFILE_DATA.OFFICES.STATE' | translate"
      ></app-autocomplete>
    </div>
    <div class="field">
      <app-autocomplete
        formControlName="city"
        url="/city"
        searchProp="Cities"
        [label]="'COMPANY_PROFILE_DATA.OFFICES.CITY' | translate"
        [parentSearchPropValue]="form.get('state')?.value?.id"
      ></app-autocomplete>
    </div>
    <div class="field">
      <kendo-floatinglabel
        [text]="'COMPANY_PROFILE_DATA.OFFICES.POST_CODE' | translate"
      >
        <kendo-textbox formControlName="postCode"> </kendo-textbox>
      </kendo-floatinglabel>
    </div>
    <div class="field">
      <kendo-floatinglabel
        [text]="
          addressLabel ?? ('COMPANY_PROFILE_DATA.OFFICES.ADDRESS' | translate)
        "
      >
        <kendo-textbox formControlName="address"> </kendo-textbox>
      </kendo-floatinglabel>
    </div>
  </form>

  <kendo-dialog-actions>
    <button kendoButton (click)="closeEdit()" themeColor="primary">
      {{ "COMMON.DONE" | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
